import { render, staticRenderFns } from "./AdminBreadcrumb.vue?vue&type=template&id=22004628"
import script from "./AdminBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminBreadcrumb.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports